import { Controller } from "@hotwired/stimulus"

export default class CoreuiOffcanvasControlController extends Controller {
  static outlets = ["coreui-offcanvas"]

  toggle(event) {
    this.coreuiOffcanvasOutlets.forEach((owner) => owner.toggle(event))
  }

  show(event) {
    this.coreuiOffcanvasOutlets.forEach((owner) => owner.show(event))
  }

  hide() {
    this.coreuiOffcanvasOutlets.forEach((owner) => owner.hide())
  }
}
